"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _typography = _interopRequireDefault(require("../typography"));

var _button = _interopRequireDefault(require("../button"));

var _tooltip = _interopRequireDefault(require("../tooltip"));

var _constants = require("./constants");

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spinner = _interopRequireDefault(require("../spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.bds-notification-card {\n  display: flex;\n  background-color: #ffffff;\n  height: 9.9375rem;\n  flex-grow: 2; }\n  .bds-notification-card:hover {\n    background-color: #f4f4f4; }\n  .bds-notification-card .bds-card-content {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 2;\n    margin: 1.5rem; }\n    .bds-notification-card .bds-card-content .bds-card-header {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between; }\n      .bds-notification-card .bds-card-content .bds-card-header .bds-card-title {\n        color: #6f6f6f; }\n      .bds-notification-card .bds-card-content .bds-card-header .bds-card-time {\n        color: #6f6f6f; }\n    .bds-notification-card .bds-card-content .bds-card-message {\n      display: flex;\n      flex-grow: 2;\n      color: #393939;\n      margin-top: 0.5rem;\n      margin-bottom: 1rem;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      -ms-text-overflow: ellipsis;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical; }\n    .bds-notification-card .bds-card-content .bds-card-action-footer {\n      display: flex;\n      flex-direction: row-reverse; }\n      .bds-notification-card .bds-card-content .bds-card-action-footer .secondary-button-spacing {\n        margin-right: 1rem; }\n\n.bds-notification-card-with-spinner-overlay {\n  position: relative; }\n";
  var fileName = "compone_notificationCard";
  var element = document.querySelector("style[data-sass-component='compone_notificationCard']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var NotificationCard = function NotificationCard(_ref) {
  var _notificationCardClas;

  var loading = _ref.loading,
      loadingMessage = _ref.loadingMessage,
      notificationTitle = _ref.notificationTitle,
      notificationTime = _ref.notificationTime,
      notificationMessage = _ref.notificationMessage,
      primaryActionLabel = _ref.primaryActionLabel,
      primaryActionHandler = _ref.primaryActionHandler,
      secondaryActionLabel = _ref.secondaryActionLabel,
      secondaryActionHandler = _ref.secondaryActionHandler,
      _ref$tooltipPosition = _ref.tooltipPosition,
      tooltipPosition = _ref$tooltipPosition === void 0 ? 'top' : _ref$tooltipPosition;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showTooltip = _useState2[0],
      setShowTooltip = _useState2[1];

  var messageRef = (0, _react.useRef)();
  var notificationCardClasses = (_notificationCardClas = {}, _defineProperty(_notificationCardClas, _constants.classes.notificationCard, true), _defineProperty(_notificationCardClas, _constants.classes.notificationCardWithSpinnerOverlay, loading), _notificationCardClas);
  (0, _react.useLayoutEffect)(function () {
    if (messageRef.current.clientHeight < messageRef.current.scrollHeight) {
      setShowTooltip(true);
    } else {
      setShowTooltip(false);
    }
  }, [messageRef]);

  var getTimeFormat = function getTimeFormat(date) {
    var notificationDate = (0, _moment.default)(date);
    var todayDate = (0, _moment.default)();
    var yesterdayDate = (0, _moment.default)().subtract(1, _constants.days);

    if (notificationDate.isSame(todayDate, _constants.days)) {
      return notificationDate.format('h:mm A');
    } else if (notificationDate.isSame(yesterdayDate, _constants.days)) {
      return "".concat(_constants.Yesterday, " ").concat(notificationDate.format('h:mm A'));
    } else {
      return notificationDate.format('MMM D');
    }
  };

  var cardHeader = function cardHeader() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.cardHeader
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.cardTitle
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "label1"
    }, notificationTitle)), /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.cardTime
    }, /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "helper1"
    }, getTimeFormat(notificationTime))));
  };

  var cardMessage = function cardMessage() {
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: messageRef,
      className: _constants.classes.cardMessage
    }, showTooltip ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      title: notificationMessage,
      position: tooltipPosition
    }, /*#__PURE__*/_react.default.createElement("div", null, cardMessageBody())) : cardMessageBody());
  };

  var cardMessageBody = function cardMessageBody() {
    return /*#__PURE__*/_react.default.createElement(_typography.default, {
      variant: "body"
    }, notificationMessage);
  };

  var cardFooterAction = function cardFooterAction() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.cardActionFooter
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: "secondary",
      size: "small",
      onClick: primaryActionHandler
    }, primaryActionLabel), secondaryActionLabel && /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.secondaryButtonSpacing
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      variant: "secondary",
      size: "small",
      onClick: secondaryActionHandler
    }, secondaryActionLabel)));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, notificationCardClasses))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.cardContent
  }, cardHeader(), cardMessage(), cardFooterAction()), loading && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "medium",
    message: loadingMessage,
    overlayOnContainer: true
  }));
};

NotificationCard.propTypes = {
  loading: _propTypes.default.bool,
  loadingMessage: _propTypes.default.string,
  notificationTitle: _propTypes.default.string.isRequired,
  notificationTime: _propTypes.default.string.isRequired,
  notificationMessage: _propTypes.default.element.isRequired,
  primaryActionLabel: _propTypes.default.string.isRequired,
  primaryActionHandler: _propTypes.default.func.isRequired,
  secondaryActionLabel: _propTypes.default.string,
  secondaryActionHandler: _propTypes.default.func
};
var _default = NotificationCard;
exports.default = _default;